import React, { useState } from 'react';
import QRCode from 'qrcode';
import './App.css';
import LoadingModal from './LoadingModal';

function QRGenerator() {
  const [scenarioId, setScenarioId] = useState<string>('');
  const [qrCodeUrl, setQrCodeUrl] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  const generateQRCode = async (id: string) => {
    if (!id.trim()) {
      setError('Please enter a valid scenario ID');
      return;
    }

    setLoading(true);
    setError('');
    setQrCodeUrl('');

    try {
      const sessionUrl = process.env.REACT_APP_SESSION_URL || window.location.origin;
      const fullUrl = `${sessionUrl}?scenario_id=${encodeURIComponent(id)}`;
      
      // Generate QR code as data URL
      const qrCodeDataUrl = await QRCode.toDataURL(fullUrl, {
        width: 300,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      });
      
      setQrCodeUrl(qrCodeDataUrl);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred while generating QR code');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    generateQRCode(scenarioId);
  };

  const getSessionUrl = () => {
    return process.env.REACT_APP_SESSION_URL || window.location.origin;
  };

  return (
    <>
      <div className="App">
        <div className="container">
          <h1>QR Code Generator</h1>
          <p>Generate a QR code that links to the session authentication page with your scenario ID.</p>
          
          <form onSubmit={handleSubmit} className="session-form">
            <div className="input-group">
              <label htmlFor="scenarioID">Enter Scenario ID:</label>
              <input
                type="text"
                id="scenarioID"
                value={scenarioId}
                onChange={(e) => setScenarioId(e.target.value)}
                placeholder="Enter your scenario ID"
                disabled={loading}
              />
            </div>

            <button type="submit" disabled={loading || !scenarioId.trim()}>
              {loading ? 'Generating QR Code...' : 'Generate QR Code'}
            </button>
          </form>

          {error && (
            <div className="error-message">
              <p>Error: {error}</p>
            </div>
          )}

          {qrCodeUrl && (
            <div className="result">
              <h2>Your QR Code:</h2>
              <div className="qr-code-container">
                <img src={qrCodeUrl} alt="QR Code" style={{ maxWidth: '100%', height: 'auto' }} />
              </div>
              <div className="qr-info">
                <p><strong>This QR code links to:</strong></p>
                <code>{getSessionUrl()}?scenario_id={scenarioId}</code>
              </div>
            </div>
          )}

          <div className="instructions">
            <h3>How to use:</h3>
            <ul>
              <li>Enter a Scenario ID in the input field and click "Generate QR Code"</li>
              <li>The QR code will link to: <code>{getSessionUrl()}?scenario_id=your-scenario-id</code></li>
              <li>Users can scan this QR code to automatically open the session page with the scenario ID pre-filled</li>
            </ul>
          </div>

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <a href="/" style={{ color: '#007bff', textDecoration: 'none' }}>
              ← Back to Session Generator
            </a>
          </div>
        </div>
      </div>
      
      <LoadingModal 
        isVisible={loading} 
        message="Generating QR code..." 
      />
    </>
  );
}

export default QRGenerator;